export default name =>
  name.toLocaleLowerCase().replace(/[^0-9a-z\u00C0-\u017E]+/gi, '-')
